<div class="d-md-flex align-items-center">
  <ng-container *ngIf="component.data$ | async as data">
    <ng-container
      [styleClassesOverride]="'puff-collection-with-links'"
      [cxComponentWrapper]="{
        flexType: 'PuffComponent',
        typeCode: 'PuffComponent',
        uid: data.puff.uid
      }"
    ></ng-container>
    <div class="col-12 col-md-4 puff-links">
      <ng-container *ngFor="let link of data.links?.links?.split(' ')">
        <ng-container
          [cxComponentWrapper]="{
            flexType: 'PuffLinkComponent',
            typeCode: 'PuffLinkComponent',
            uid: link
          }"
        ></ng-container>
      </ng-container>
    </div>
  </ng-container>
</div>
